import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex, FlexProps } from '@qga/roo-ui/components';
import ItemLink from './ItemLink';

interface ItemLinksProps extends Partial<FlexProps> {
  links: Array<{
    label: string;
    url: string;
  }>;
}

const StyledFlex = styled(Flex)`
  min-width: 166px;
`;

const ItemLinks = ({ links = [], ...props }: ItemLinksProps) => (
  <StyledFlex flexDirection="column" {...props}>
    {links.map((linkProps, index) => (
      <ItemLink {...linkProps} key={`item-link-${index}`} />
    ))}
  </StyledFlex>
);

ItemLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
};

export default ItemLinks;
